/**
 * Enum defining the type of animations supported by InputBlock
 */
export enum AnimatedInputBlockTypes {
    /** No animation */
    None,
    /** Time based animation. Will only work for floats */
    Time
}